import { FC, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { managerMeState, managerTokenState } from '../plugins/ridge';

interface ManagerRouteProps {
  element: JSX.Element;
}

export const ManagerRoute: FC<ManagerRouteProps> = ({ element: Element }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const token = managerTokenState.useValue();
  const me = managerMeState.useValue();

  useEffect(() => {
    if (!token) {
      // 로그인 후 원래 목적지(경로+쿼리)로 복귀할 수 있도록 redirect로 전달.
      // 알림톡 딥링크(?workDate=&companyId=)처럼 세션 없이 진입한 경우
      // 로그인 뒤 해당 필터 화면으로 정확히 착지하게 한다.
      const target = `${location.pathname}${location.search}${location.hash}`;
      navigate(`/manager/login?redirect=${encodeURIComponent(target)}`, {
        replace: true,
      });
    }
  }, [token, me, navigate, location]);

  if (!token) {
    return <></>;
  }

  return Element;
};
